// low level polyfills, for vendor libs, etc.

angular.lowercase = function(text) {
  return angular.isString(text) ? text.toLowerCase() : text;
};
